<template>
  <div class="new-dialog">
    <el-dialog :visible.sync="newModalVisible" width="592px" :before-close="handleClose" :close-on-click-modal="closeonclickmodal" v-el-drag-dialog>
      <div slot="title" class="task-modal-title">
        <span class="modal-title-span">{{modalTitle}}</span>
      </div>
      <slot name="content"></slot>
      <div slot="footer" class="task-modal-footer">
        <slot name="footer"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'hignModal',
  props: {
    isOneBtn: {
      type: Boolean,
      default: false
    },
    newModalVisible: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: '新建任务'
    },
    agreeBtn: {
      type: String,
      default: '确定'
    },
    //是否点击空白处关闭弹窗
    closeonclickmodal:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    // 弹窗关闭触发
    handleClose() {
      this.$emit('closeNewTask');
    },
    // 确认
    agreeAdd() {
      this.$emit('addNewTask');
    },
    // 取消
    closeModal() {
      this.$emit('closeNewTask');
    }
  }
}
</script>

<style lang="scss">
.new-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #D4D4D7;
    padding: 11px 16px;
    line-height: normal;
    .el-dialog__headerbtn {
      top: 11px;
      right: 16px;
    }
    .task-modal-title {
      .modal-title-icon {
        font-size: 12px;
      }
      .modal-title-span {
        font-size: 12px;
        color: #2E4057;
        font-weight: bold;
      }
    }
  }
  .el-dialog__body {
    height: 276px;
    padding: 16px;
    text-align: center;
    overflow-y: auto;
    .el-form-item {
      display: inline-block;
      margin-bottom: 8px;
    }
    .new-task-input {
      width: 316px;
    }
    .new-task-textarea {
      width: 316px;
      textarea {
        height: 102px;
      }
    }
  }
  .el-dialog__footer {
    border-top: 1px solid #D4D4D7;
    padding: 16px;
    line-height: normal;
    .task-modal-footer {
      font-size: 0;
      .el-button {
        // padding: 0 !important;
        margin-left: 8px !important;
      }
      .modal-footer-two {
        // width: 48px;
        height: 28px;
      }
      .modal-footer-four {
        // width: 72px;
        height: 28px;
      }
    }
  }
}
</style>
